import moment from 'moment';

import { hashHistory   } from 'react-router'; 
import { loadMessages } from '../actions/messageActions';
import * as types from '../constants/actionTypes';
import { rootDomainAuth } from '../constants/config'
import { resourceApi, authServer } from '../utils/fetchUtil';
import { getToken, setToken } from '../utils/tokenUtil';
import { checkForScriptUpdates, showGlobalSpinner, hideGlobalSpinner, showGlobalMessage, getUserLocation, submitVersions  }  from './environmentActions';





export function getTokenTimestamp() {
  //return dispatch => {
      return window.localStorage.getItem(window._tokenTimestamp);
  //};
}



export function tryGetNewAccessToken() {

  return getUserRefreshToken().then((refreshToken) => {
    if(!refreshToken) {
      return;
    }
  
    let config = {
        method: 'POST',
        url: 'connect/token',
        data: `grant_type=refresh_token&scope=offline_access&refresh_token=${refreshToken}`
    }
    
    return authServer(config)
        .then(object => {
            return object.data.access_token;
        }).catch(function(err) {
            console.log(err);
        });
  });

  
}

function getUserRefreshToken(){

  let config = {
      method: 'get',
      url: `auth/refresh_token`
  };

  return resourceApi(config)
  .then(response => {
      return response.data;
  })
  .catch(function (error) {
      console.log(error);
      return null;
  });
}


export function updateUserRefreshToken(token){

  let config = {
      method: 'post',
      url: `auth/refresh_token`,
      data: {
        Token: token
      }
  };

  return window._fetcher.publicApi(config);
  
}

function requestLogout() {
  return {
    type: types.LOGOUT_REQUEST,
    isAuthenticated: true
  }
}

function receiveLogout() {
  return {
    type: types.LOGOUT_SUCCESS,
    isAuthenticated: false
  }
}


// export function saveRegState(creds) {
//   return {
//     type: types.SAVE_REG_STATE,
//     creds: creds
//   }
// }

// export function clearRegState() {
//   return {
//     type: types.CLEAR_REG_STATE
//   }
// }

// export function showGlobalSpinner() {
//   return {
//     type: types.SHOW_SPINNER
//   }
// }

// export function hideGlobalSpinner() {
//   return {
//     type: types.HIDE_SPINNER
//   }
// }

export function passwordError(message) {

  return {
    type: types.PASSWORD_ERROR,
    message
  }
}


export function recievePasswordConfirmation() {

  return {
    type: types.PASSWORD_SUCCESS

  }
}

export function logoutUser() {

   return dispatch => {
      dispatch(requestLogout());
      localStorage.removeItem('id_token');
      localStorage.removeItem('token_timestamp');
      dispatch(receiveLogout());
      hashHistory.push("/");
    
  }
}


export function sessionExpired() {
    localStorage.removeItem('id_token');
    localStorage.removeItem('token_timestamp');
    hashHistory.push("/");
}



function setKeychain(username, password) {

  return dispatch => {

    if(window.NativeStorage) {

      window.NativeStorage.setItem('medefyusername', username, function(obj){ } , function(code) {  });

      window.dasKeychain.setForKey(function(){
          //alert('Key set!')
        }, 
        function(msg){ 
          //alert('Key not set: ' + msg)
        }, 
        username, 
        'medefyservice', 
        password
      );
    }
  }
}


export function login(username, password) {

  return (dispatch) => {
      //dispatch(showGlobalSpinner());

      dispatch(loginUser(username, password));

     
      //dispatch(showGlobalMessage(error.data.message));
  }
}


export function loginUser(username, password) {

  
  return (dispatch, getState) => {

    //note encodeURIComponent() prevents the blowing up of passwords with the + :D

    var config = {
      method: 'POST',
      url: 'connect/token',
      data: 'username=' + escape(username) + '&password=' + encodeURIComponent(password) + '&grant_type=password&scope=offline_access'
    };

    authServer(config, dispatch)
      .then(response => {

        dispatch(setToken(response.data.access_token));
        
        dispatch(setKeychain(username, password));

        dispatch(hasVerifiedIdentity());
        
        updateUserRefreshToken(response.data.refresh_token);

        if(window.NativeStorage){
          window.NativeStorage.setItem('medefykeychaincrash', false, ()=>{ console.log("Setting Crash Detection To False")}, ()=>{})
        }
        submitVersions();

      })
      .catch(function (error) {
          console.log(error);
      });
  };
}

function updateUserRefreshToken(token){

  let config = {
      method: 'post',
      url: `auth/refresh_token`,
      data: {
        Token: token
      }
  };

  resourceApi(config);
  
}

export function getUserProfile() {

  return (dispatch, getState) => {

      var token = getToken();
      const isRefresh = getState().thisApp.auth.member ? true : false;
      
      if(token) {
        let config = {
          method: 'get',
          url: `auth/profile/${isRefresh}`
        };

        resourceApi(config, dispatch)
        .then(response => {
          if(!isRefresh){
            cacheBuster();
          }

          dispatch(receiveProfile(response.data));

          try {
            if(window.firebaseAnalytics && response.data.ClientUserID){
              window.firebaseAnalytics.setUserId(response.data.ClientUserID.toString()).then();
            } else {
              console.log("firebaseAnalytics Method Not Present")
            }
          }
          catch (err){
            console.log("Unable to Set ID:", err)
          }
          
        })
        .catch(function (error) {
            console.log(error.data);

            switch(error.data){
              case "Date Error": 
                hashHistory.push('/go/outofdate'); //active client but outside of benifits, eventually should roll up into the end page with custom content
                break;
              case "Service Error":
                hashHistory.push('/go/end/')
                break;
              default:
                break;
            }
            // if(error.data == "Date Error")
            // {
            //   hashHistory.push('/go/outofdate')
            // }
        });
      }
      else {
        hashHistory.push("/");
      }
  }
}

function cacheBuster() {
      let config = {
        method: 'get',
        url: `member/insuranceCardCacheBuster`
      };

      return resourceApi(config)
      .then(response => {
          console.log("Cache Buster Has Completed")        
      })
      .catch(function (error) {
          console.log(error.data);
      });
}

function receiveProfile(profile) {
  
  if(profile.FirstName && !/[a-z]/.test(profile.FirstName)){
    profile.FirstName = `${profile.FirstName.slice(0,1).toUpperCase()}${profile.FirstName.slice(1).toLowerCase()}`
  }
  return {
    type: types.RECEIVE_PROFILE,
    profile: profile
  }
}


export function goToLogin() {
  
  hashHistory.push("/");

  return {
    type: types.PASSWORD_COMPLETE,
    passwordReset: false
  }
}


export function hasVerifiedEmail() {

  let config = {
    method: 'GET',
    url: 'account/verified',
  }

  return dispatch => {

    return authServer(config, dispatch)
      .then(object => {

        if(object.status == 403) {
            //dispatch(showGlobalMessage("You must complete your identity verification before you can use the app.", true));
            hashHistory.push('go/accesscode');   
        }
        else {
            dispatch(hasVerifiedIdentity());
        }
      }).catch(function(err) {
          console.log(err);
      });
  }
}


export function setPassword(creds) {  

  let config = {
    method: 'POST',
    url: 'account/changepassword',
    data: creds
  }

  return dispatch => {

    return authServer(config, dispatch)
      .then(response =>  {
          dispatch(recievePasswordConfirmation());
          dispatch(showGlobalMessage("Your password has been changed successfully!", false));
          hashHistory.push('account');   
      }).catch(err => {
        dispatch(showGlobalMessage("An error occured while updating your password. Please confirm that your Old Password is correct and that your New Password contains at least 8 characters.", false));

        console.log("Error: ", err)
      })
  }
}


export function changePassword(creds) {  

  console.log(creds);

  let config = {
    method: 'POST',
    url: 'account/changepassword',
    data: creds
    //`username=${creds.username}&password=${creds.password}&grant_type=password`
  }

  return dispatch => {

    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds))

    return authServer(config, dispatch, true)
      // .then(response =>
      //   response.json().then(user => ({ user, response }))
      // )
      .then(response =>  {
        if (!response.ok) {
          // If there was a problem, we want to
          // dispatch the error condition

          if(response.statusText ==="Negative")
          {
            dispatch(logoutUser());
          }
          else{
            dispatch(passwordError(response.statusText))
          }
          

          return Promise.reject(response)
        }
        else {
          
          // Dispatch the success action
          dispatch(recievePasswordConfirmation())
        }
      }).catch(err => console.log("Error: ", err))
  }
}


export function resetPassword(creds) {  

  console.log(creds);

  let config = {
    method: 'POST',
    url: 'account/resetpassword',
    data: creds
    //`username=${creds.username}&password=${creds.password}&grant_type=password`
  }

  return dispatch => {

    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds))

    return authServer(config, dispatch, true)
      .then(response =>  {
        if (response.status !== 200) {
          // If there was a problem, we want to
          // dispatch the error condition

          if(response.statusText ==="Negative")
          {
            dispatch(logoutUser());
          }
          else{
            dispatch(showGlobalMessage(response.message))
          }
          

          return Promise.reject(response)
        }
        else {
          
            // Dispatch the success action
            dispatch(recievePasswordConfirmation());

            if(window.dasKeychain) {
                window.dasKeychain.setForKey(function(){}, function() {}, creds.Email, 'medefyservice', creds.Password);
            }

        }
      }).catch(err => console.log("Error: ", err))
  }
}

export function sendPasswordChangeEmail(email) {  


  let config = {
    method: 'POST',
    url: 'account/sendPasswordChangeEmail',
    data: {
      Email: email
    }
  }

  return dispatch => {

    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds))

    return authServer(config, dispatch)
      .then(response =>  {
        
        if (response.status == 200) {
            dispatch(showGlobalMessage("The email has been sent. Once you get the code, enter it below, along with your new password."));
            dispatch(receiveIdentity());
        }

      }).catch(err => console.log("Error: ", err))
  }
}

export function requestIdentityVerification(creds){
  return {
    type: types.IDENTITY_REQUEST,
    creds: creds
  }
}

export function identityError(message) {

  return {
    type: types.IDENTITY_ERROR,
    message
  }
}

export function receiveIdentity() {

  return {
    type: types.IDENTITY_SUCCESS,
    isIdentified: true
  }
}

export function markAccountVerified() {
  return {
    type: types.ACCOUNT_VERIFIED,
    verified: true
  }
}


export function identityVerifiedRoutines() {
  return dispatch => {
    try{
      dispatch(receiveIdentity());
      dispatch(deliverInitialMessages());
      //dispatch(showGlobalMessage("Your account is now active!"))
      dispatch(refreshDeviceToken());
      dispatch(loadMessages());
      dispatch(hideGlobalSpinner());
    } 
    catch(err){}
  }
}

// export function identifyUser(creds) {
  
//   return dispatch => {

//     dispatch(requestIdentityVerification(creds));

//     let config = {
//       method: 'POST',
//       url: 'auth/identify',
//       headers: { 'Content-Type':'application/json' },
//       data: {
//         FirstName: creds.firstname,
//         LastName: creds.lastname,
//         Last4SSN: creds.last4,
//         DOBMonth: creds.month,
//         DOBDay: creds.day,
//         DOBYear: creds.year
//       }
//     };

//     return resourceApi(config, dispatch)
//      .then(object =>  {
        
//         dispatch(receiveIdentity());
//         dispatch(deliverInitialMessages());
//         dispatch(showGlobalMessage("Your account is now active!"))
//         dispatch(refreshDeviceToken());
//         dispatch(loadMessages());
//         dispatch(hideGlobalSpinner());
//         hashHistory.push('home');
//       });
//   }
// }

export function deliverInitialMessages() {
  
  return dispatch => {

    let config = {
      method: 'GET',
      url: 'member/deliverInitialMessages'
    };

    return resourceApi(config, dispatch)
     .then(object =>  {
       //dispatch(loadMesssages())?
      })
      .catch(err => console.log("Error: ", err))
  }
}

export function verifyUser(code) {

  let config = {
    method: 'POST',
    url: 'account/verifycode',
    data: {
      Code: code
    }
  };
  
  return dispatch => {

    return authServer(config, dispatch)
     .then(object =>  {

      if(object.status == 200)
        {
            dispatch(markAccountVerified());
            
        }

      //  browserHistory.push('identity');
     
      })
      .catch(err => console.log("Error: ", err))
  }
}

export function resendRegistrationEmail() {
  
  let config = {
    method: 'get',
    url: 'account/resendverification',
  };
  
  return dispatch => {

    return resourceApi(config, dispatch)
     .then(object =>  {

        //  alert('verification here');
      })
      .catch(err => console.log("Error: ", err))
  }
}


// Calls the API to get a token and
// dispatches actions along the way
export function hasVerifiedIdentity() {

  let config = {
    method: 'GET',
    url: 'auth/verified',
  }

  return (dispatch) => {
  
    dispatch(showGlobalSpinner()); 

    return resourceApi(config, dispatch)
      .then(object => {
       
        if(object.status === 400) {
            //dispatch(showGlobalMessage("You must complete your identity verification before you can use the app.", true));
            hashHistory.push('/go/identity');   
        }
        else {
          //hashHistory.push('/home');  now in checkForScriptUpdates method
          dispatch(markAccountVerified());
          //dispatch(loadMessages());
          dispatch(refreshDeviceToken());
          dispatch(checkForScriptUpdates());
          dispatch(hideGlobalSpinner());
        }
  
      }).catch(function(err) {
          console.log(err);
          if(err.status === 400) {
              //dispatch(showGlobalMessage("You must complete your identity verification before you can use the app.", true));
              hashHistory.push('/go/identity');   
          }
          dispatch(hideGlobalSpinner());


      });
    //   .finally(function() {
    //       dispatch(hideGlobalSpinner());
    //  });
    }
}
  
  
// This method gets caled from the method above and the onTokenRefresh callback method.
export function updateFcmToken(token) {  

  let payload = {
    method: 'POST',
    url: `auth/refreshtoken`,
    data:{
      Token: token
    }
  };

  return dispatch => {
    return resourceApi(payload, dispatch, false);
  }
}

// This method should only get called from authentication routine after a token has been established
export function refreshDeviceToken() {  
  return (dispatch) => {

    // Legacy method
    if(window.FCMPlugin && window.FCMPlugin.getToken) {
      
      window.FCMPlugin.getToken(
          function (token) {
              if (token) {
                dispatch(updateFcmToken(token));
              } 
          },
          function (err) {
              console.log('error retrieving token: ' + err);
          }
      );
    }
    else{
      // New implementation, token fecthed and stored to localStorage on device browser.
      var token = window.localStorage.getItem('fcmtoken');
      if(token != null){
        dispatch(updateFcmToken(token));
      }
    }   
  }
}




// WEBPACK FOOTER //
// ./src/actions/authActions.js